import { trackById } from 'src/app/shared/utils/track-by.util';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';
import { ToastService } from 'src/app/services/toast.service';
import { Comment } from 'src/app/models/comment.model';
import { AuthService } from 'src/app/services';
import { CommentService } from 'src/app/services/comment.service';
import { DateFormatService } from 'src/app/services/dateFormat.service';
import { ErrorConstants } from 'src/app/shared/constants/error.constants';

@Component({
  standalone: false,
  selector: 'app-comments-notes',
  templateUrl: './comments-notes.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./comments-notes.component.scss']
})
export class CommentsNotesComponent implements OnInit {
  @Input() comments;
  @Input() tasksAssignmentNotes;
  @Input() loadCommentsAndNotes;
  @Input() loadingAssessments;

  @Output() updateGraphAndNotes = new EventEmitter<any>();
  @Output() showCommentRangeEmit = new EventEmitter<any>();
  @Output() showNoteRangeEmit = new EventEmitter<any>();

  selectedComment: Comment;
  showEditComment: boolean = false;
  triggerPopulateForm: boolean = false;
  userTimeZone: string = "";
  dateFormatHMSA = "";
  errorHtml: string = "";

  constructor(private toastService: ToastService,
    private authService: AuthService,
    private commentService: CommentService,
    private loaderService: LoaderService,
    private dateFormatService: DateFormatService) {
      this.userTimeZone = this.authService.getCurrentUser().userTimeZone;
      this.errorHtml = ErrorConstants.errorHtml;
    }

  ngOnInit(): void {
    this.dateFormatHMSA = this.dateFormatService.dateFormatHMSA;
  }

  editComment(event, comment) {
    event.stopPropagation();
    this.selectedComment = comment;
    this.triggerPopulateForm = true;
    setTimeout(() => {
      this.showEditComment = true;
    }, 200);
  }

  resetTriggerPopulateForm() {
    this.triggerPopulateForm = false;
  }

  hideEditForm() {
    this.showEditComment = false;
  }

  updateGraphAndNotesFn() {
    this.updateGraphAndNotes.emit(true);
  }

  showCommentRange(comment) {
    this.showCommentRangeEmit.emit(comment);
  }

  showNoteRange(note) {
    this.showNoteRangeEmit.emit(note);
  }

  deleteComment(event, id) {
    event.stopPropagation();
    this.loaderService.show();
    this.commentService.delete(id).subscribe(
      data => {
        this.toastService.showSuccess('Comment deleted successfully', true);
        this.updateGraphAndNotes.emit(true);
        this.loaderService.hide();
      },
      error => {
        this.toastService.displayErrorMessage('Something went wrong', true);
        this.loaderService.hide();
      }
    );
  }

  public trackById = trackById;
}
